var React = require('react');

function CrossSell (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_70264","data-name":"Group 70264","transform":"translate(-1383 -230)"},[React.createElement("path",{"id":"Icon_material-done","data-name":"Icon material-done","d":"M9.31,16.37,6.153,13.212,5.1,14.264l4.21,4.21,9.022-9.022L17.28,8.4Z","transform":"translate(1383.547 228.659)","fill":"#fff","key":0}),React.createElement("g",{"id":"Group_70306","data-name":"Group 70306","key":1},React.createElement("g",{"id":"Ellipse_172","data-name":"Ellipse 172","transform":"translate(1383 230)","fill":"none","stroke":"#fff","strokeWidth":"1"},[React.createElement("circle",{"cx":"12","cy":"12","r":"12","stroke":"none","key":0}),React.createElement("circle",{"cx":"12","cy":"12","r":"11.5","fill":"none","key":1})]))]));
}

CrossSell.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = CrossSell;

CrossSell.default = CrossSell;
